const recaptchakey = process.env.REACT_APP_RECAPTCHA_SITE_KEY;
const base_root = window.location.host

let apiUrl = '';

if (base_root === "polarcare.polar-air.com") {
      apiUrl = 'https://api-polarserv.polar-air.com';
}
else if (base_root === "polarcare-staging.polar-air.com") {
      apiUrl = 'https://api-polarserv-staging.polar-air.com';
}
else if (base_root === "alsamart.com") {
      apiUrl = 'https://api-prod.alsamart.com';
}
else if (base_root === "dev.alsamart.com") {
      apiUrl = 'https://api-dev.alsamart.com';
}
else if(base_root === "app.sanricardoshipping.com" || 
        base_root === "dashboard.sanricardoshipping.com" || 
        base_root === "admin.sanricardoshipping.com" || 
        base_root === "booking.sanricardoshipping.com" || 
        base_root === "sanricardoshipping.com"
) {
      apiUrl = 'https://api-prod.sanricardoshipping.com';
}
else if(base_root === "sandbox.sanricardoshipping.com") {
      apiUrl = 'https://api-sandbox.sanricardoshipping.com';
}
else if (base_root === "app.topventory.com") {
//else if (base_root === "app.asinso.com" || base_root === "www.asinso.com" || base_root === "app.asinso.net" || base_root === "asinso.net" || base_root === "www.asinso.net" || base_root === "app.topventory.com") {
      apiUrl = process.env.REACT_APP_API_PROD_URL;
}
else if (base_root === "beta.topventory.com") {
      apiUrl = process.env.REACT_APP_API_BETA_URL;
}
else if (base_root === "demo.topventory.com") {
      apiUrl = process.env.REACT_APP_API_DEMO_URL;
}
else{
      apiUrl = process.env.REACT_APP_API_DEV_URL;
}

const appConfig = {
      apiUrl,
      recaptchakey
}

export default appConfig;